import { render } from "./CompanyAccount-YourPhoneNumbers.vue?vue&type=template&id=c5816f10&scoped=true"
import script from "./CompanyAccount-YourPhoneNumbers.vue?vue&type=script&lang=js"
export * from "./CompanyAccount-YourPhoneNumbers.vue?vue&type=script&lang=js"

import "./CompanyAccount-YourPhoneNumbers.vue?vue&type=style&index=0&id=c5816f10&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5816f10"]])

export default __exports__